import React from 'react';
import { CONSTANTS } from '../utils/constants';
import { scrollToOffer } from '../utils/scroll';
export const HeroSection: React.FC = () => {
  return <section className="pt-24 pb-12 px-4 bg-gradient-to-b from-blue-50 to-white overflow-hidden" data-id="element-112">
      <div className="max-w-6xl mx-auto text-center" data-id="element-113">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-blue-900 mb-6 leading-tight" data-id="element-114">
          Diseña entrenamientos que realmente funcionen —{' '}
          <span className="text-blue-600" data-id="element-115">sin desperdiciar horas</span> probando
          qué sirve y qué no
        </h1>

        <p className="text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto mb-10" data-id="element-116">
          El sistema completo para crear planes de entrenamiento efectivos,
          sesiones listas para usar y tácticas reales que tus atletas pueden
          aplicar desde el primer día.
        </p>

        <div className="relative max-w-3xl mx-auto mb-8 cursor-pointer group flex justify-center items-center" onClick={scrollToOffer} data-id="element-117">
          {/* Background glow */}
          <div className="absolute inset-0 bg-blue-400/20 blur-3xl rounded-full scale-75 group-hover:scale-90 transition-transform duration-500" data-id="element-118"></div>

          {/* Combo Image Only */}
          <img src={CONSTANTS.IMAGES.COMBO} alt="Combo Completo" className="relative w-[80%] md:w-[60%] rounded-xl shadow-2xl z-10 group-hover:scale-105 group-hover:-translate-y-2 transition-all duration-300" data-id="element-119" />
        </div>

        <p className="text-lg font-semibold text-gray-600 mb-8" data-id="element-120">
          Megapack Fútbol + 6 Bonus Gratuitos
        </p>

        <button onClick={scrollToOffer} className="bg-green-500 hover:bg-green-600 text-white text-xl md:text-2xl font-bold py-4 px-8 rounded-full shadow-[0_0_20px_rgba(34,197,94,0.5)] hover:shadow-[0_0_30px_rgba(34,197,94,0.7)] transition-all animate-pulse-fast" data-id="element-121">
          Quiero el pack completo ahora
        </button>
      </div>
    </section>;
};